import { render, staticRenderFns } from "./OrderSalaryAddEdit.vue?vue&type=template&id=2e90e032&"
import script from "./OrderSalaryAddEdit.vue?vue&type=script&lang=js&"
export * from "./OrderSalaryAddEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports